// src/components/BottomNav.tsx
import { useNavigate, useLocation } from 'react-router-dom';
import { FiHome, FiList, FiUser } from 'react-icons/fi';

type Tab = 'home' | 'nba' | 'nhl' | 'tracker' | 'profile';

function BasketballIcon({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c-2.7 2.1-4 5.1-4 9s1.3 6.9 4 9M12 3c2.7 2.1 4 5.1 4 9s-1.3 6.9-4 9" />
    </svg>
  );
}

function HockeyIcon({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="m7 3 8 16c.5 1 1.4 1.5 2.5 1.2l3.5-.8" />
      <ellipse cx="19.5" cy="22" rx="2.2" ry=".8" fill="currentColor" stroke="none" />
    </svg>
  );
}

const tabs: { id: Tab; icon: React.ReactNode; label: string }[] = [
  { id: 'home', icon: <FiHome size={22} />, label: 'Início' },
  { id: 'nba', icon: <BasketballIcon />, label: 'NBA' },
  { id: 'nhl', icon: <HockeyIcon />, label: 'NHL' },
  { id: 'tracker', icon: <FiList size={22} />, label: 'Tracker' },
  { id: 'profile', icon: <FiUser size={22} />, label: 'Perfil' },
];

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const active = (() => {
    const path = location.pathname.replace('/', '');
    return (tabs.find(t => t.id === path)?.id ?? (path === 'bankroll' ? 'tracker' : 'home')) as Tab;
  })();

  const handleTab = (tab: Tab) => {
    navigate(tab === 'home' ? '/' : `/${tab}`);
  };

  return (
    <nav className="bottom-nav" aria-label="Navegação principal" style={{
      position: 'fixed', bottom: 'calc(10px + env(safe-area-inset-bottom, 0px))', left: '50%', transform: 'translateX(-50%)',
      width: 'min(520px, calc(100% - 28px))', display: 'flex', justifyContent: 'space-around',
      background: 'rgba(17, 19, 21, 0.96)', backdropFilter: 'blur(16px)',
      border: '1px solid #292D30', borderRadius: 30, padding: 7, zIndex: 100,
      boxShadow: '0 12px 40px rgba(0,0,0,.48)',
    }}>
      {tabs.map(({ id, icon, label }) => {
        const selected = active === id;
        return (
          <button
            key={id}
            type="button"
            aria-label={label}
            aria-current={selected ? 'page' : undefined}
            title={label}
            onClick={() => handleTab(id)}
            style={{
              flex: 1, minWidth: 0, height: 48, display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center', justifyContent: 'center',
              background: selected ? 'linear-gradient(180deg, #C9FF36, #B7FF00)' : 'transparent',
              border: 'none', borderRadius: 24, color: selected ? '#10130B' : '#9DA1A4',
              padding: 0, cursor: 'pointer', transition: 'background .18s ease, color .18s ease',
            }}
          >
            <span aria-hidden="true" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</span>
            <small style={{ fontSize: 9, fontWeight: 700, lineHeight: 1 }}>{label}</small>
          </button>
        );
      })}
    </nav>
  );
}
